import React, { ReactNode } from "react";
import styles from "./index.module.scss";

export const Form = ({ children }: { children: ReactNode }) => {
  return <form className={styles.form}>{children}</form>;
};
